import { InfoCircleOutlined } from '@ant-design/icons'
import { Button, ButtonProps, Modal } from 'antd'
import Title from 'antd/es/typography/Title'
import React, { FunctionComponent, memo, useMemo } from 'react'

import { useToggleState } from '../../utils/useToggleState'
import { AuctionMonitoringLinkedPropertyForm } from '../AuctionMonitoringLinkedPropertyForm/AuctionMonitoringLinkedPropertyForm'
import { AuctionMonitoringLinkedPropertyHelp } from '../AuctionMonitoringLinkedPropertyHelp/AuctionMonitoringLinkedPropertyHelp'
import { AuctionMonitoringLinkedPropertyModalButtonTrigger } from '../AuctionMonitoringLinkedPropertyModalButtonTrigger/AuctionMonitoringLinkedPropertyModalButtonTrigger'
import { AuctionMonitoringLinkedPropertyTableContainer } from '../AuctionMonitoringLinkedPropertyTableContainer/AuctionMonitoringLinkedPropertyTableContainer'
import { Fade } from '../Fade/Fade'

export interface AuctionMonitoringLinkedPropertyModalButtonProps {
  auctionId: string
  propertyCount?: number
  buttonProps?: ButtonProps
  shortAssignTtitle?: boolean
}

export const AuctionMonitoringLinkedPropertyModalButton: FunctionComponent<AuctionMonitoringLinkedPropertyModalButtonProps> =
  memo(props => {
    const [open, toggleModal] = useToggleState()
    const [help, toggleHelp] = useToggleState()

    const footer = useMemo(() => {
      return (
        <div className="flex justify-end">
          <Button
            icon={<InfoCircleOutlined />}
            type="link"
            onClick={toggleHelp}
          >
            {help ? 'Skrýt nápovědu' : 'Zobrazit nápovědu'}
          </Button>
          <Button type="default" onClick={toggleModal}>
            Zavřít
          </Button>
        </div>
      )
    }, [help, toggleHelp, toggleModal])

    return (
      <>
        <AuctionMonitoringLinkedPropertyModalButtonTrigger
          propertyCount={props.propertyCount}
          buttonProps={props.buttonProps}
          shortAssignTtitle={props.shortAssignTtitle}
          toggleModal={toggleModal}
        />

        {open && (
          <Modal
            title="Přiřadit nemovitost"
            open={open}
            width={1000}
            onCancel={toggleModal}
            footer={footer}
          >
            <AuctionMonitoringLinkedPropertyForm auctionId={props.auctionId} />
            <Fade show={!!props.propertyCount} className="my-8">
              <Title level={5} className="mb-3">
                Přiřazené nemovitosti k dražbě
              </Title>
              <AuctionMonitoringLinkedPropertyTableContainer
                viewType="modal"
                auctionId={props.auctionId}
              />
            </Fade>
            <Fade show={help} className="mt-8 space-y-4">
              <Title level={5}>Nápověda: Párování dražby s nemovitostí</Title>
              <AuctionMonitoringLinkedPropertyHelp defaultActiveKey="url" />
            </Fade>
          </Modal>
        )}
      </>
    )
  })
